module.exports = __webpack_public_path__ + "static/paragraph-4-0bb3fc6ce21a0fed2a556a9cd471665f.svg";